var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('qa.pageTitle'),"description":_vm.$t('qa.pageSubtitle'),"to":{ name: _vm.RouteName.Interactive }}},[_c('QaList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }